import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import { PtrnCampoEditableInt } from '../../../patronTypes';
import { EditableProps } from '../campoEditableTypes';
import { getNoBorderSx, useInputStyles } from '../campoEditableUtils';
import { PtrnPropsUtil } from '../../../patronUtils';

function CampoEditableInt(
   props: { campoConfig: PtrnCampoEditableInt } & EditableProps & { ErrorComponent?: React.ReactNode }
) {
   const { campoConfig, ...editableProps } = props;
   const classes = useInputStyles();

   const auxParam = {
      camposData: editableProps.camposData,
      campoConfig: campoConfig,
      ptrnRef: editableProps.ptrnRef,
      ruta: editableProps.ruta,
      index: editableProps.index
   };

   const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
      const name = e.target.name;
      let newValue = e.target.value;
      editableProps.onChange(name, newValue, auxParam);
   };
   const handleOnBlur: React.FocusEventHandler<HTMLInputElement> = (e) => {
      if (editableProps.onBlur) {
         const name = e.target.name;
         let newValue = e.target.value;
         editableProps.onBlur(name, newValue, auxParam);
      }
   };

   const handleOnFocus: React.FocusEventHandler<HTMLInputElement> = (e) => {
      setTimeout(() => e.target.select(), 0); // Asegura la selección completa del texto
   };

   const id = PtrnPropsUtil.genIdCampoEditable(campoConfig);
   const endAdornments = props.ErrorComponent ? (
      <InputAdornment position="end">{props.ErrorComponent}</InputAdornment>
   ) : campoConfig.prefix ? <InputAdornment position="end">{campoConfig.prefix}</InputAdornment> : undefined;

   return (
      <FormControl fullWidth error={Boolean(props.ErrorComponent)}>
         <InputLabel htmlFor={id}>{campoConfig.label}</InputLabel>
         <OutlinedInput
            sx={getNoBorderSx(campoConfig)}
            className={classes.classes.ceFocused}
            id={id}
            name={campoConfig.name}
            label={campoConfig.label}
            value={editableProps.value}
            onChange={handleOnChange}
            onFocus={campoConfig.seleccionarTodo ? handleOnFocus : undefined}
            endAdornment={endAdornments}
            fullWidth
            inputProps={{
               style: { textAlign: campoConfig.alinearTexto || 'right' }
            }}
            size="small"
         />
      </FormControl>
   );
}

export default CampoEditableInt;
